$(document).ready(function () {
	// init foundarion
	// $(document).foundation(); // 確保 Foundation 已宣告

	var applySwiper = new Swiper('#apply-swiper', {
		//- slidesPerView: 1,
		// autoHeight: true,
		updateOnWindowResize: true,
		// lazy: true,
		// enabled: true,
		navigation: {
			nextEl: '#apply-swiper .swiper-button-next',
			prevEl: '#apply-swiper .swiper-button-prev',
			// hiddenClass: 'swiper-button-hidden',
		},
		pagination: {
			el: '#apply-swiper .swiper-pagination',
			clickable: true,
		},
		on: {
			slideChangeTransitionEnd: function (swiper) {
				const newHeight = $(swiper.slides[(swiper.realIndex)]).height();
				// $(swiper.wrapperEl).height(newHeight);
				// if(swiper.realIndex){
				// }
			},
		},

	});

});